/**
 * FileManager API Endpoints
 *
 * Centralized endpoint definitions following screaming architecture pattern.
 * All endpoints are defined here for easy discovery and maintenance.
 */

const FOLDERS_BASE = "/folders";

export const FILE_MANAGER_ENDPOINTS = {
  // Folder operations
  CREATE_FOLDER: FOLDERS_BASE,
  LIST_FOLDERS: FOLDERS_BASE,
  LIST_ROOT_FOLDERS: `${FOLDERS_BASE}/root`,
  LIST_ALL_NODES: `${FOLDERS_BASE}/list_all`,
  NAVIGATE_TO_FOLDER: `${FOLDERS_BASE}/navigate`,
  GET_FOLDER: (id: string | number) => `${FOLDERS_BASE}/${id}`,
  UPDATE_FOLDER: (id: string | number) => `${FOLDERS_BASE}/${id}`,
  DELETE_FOLDER: (id: string | number) => `${FOLDERS_BASE}/${id}`,

  // Entry operations
  CREATE_ENTRY: (folderId: string | number) => `${FOLDERS_BASE}/${folderId}/entries`,
  LIST_ENTRIES: (folderId: string | number) => `${FOLDERS_BASE}/${folderId}/entries`,
  GET_ENTRY: (folderId: string | number, entryId: string | number) =>
    `${FOLDERS_BASE}/${folderId}/entries/${entryId}`,
  UPDATE_ENTRY: (folderId: string | number, entryId: string | number) =>
    `${FOLDERS_BASE}/${folderId}/entries/${entryId}`,
  DELETE_ENTRY: (folderId: string | number, entryId: string | number) =>
    `${FOLDERS_BASE}/${folderId}/entries/${entryId}`,
} as const;
